import { app } from '../app';

class HardTokenResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    u2fLoginStart(username) {
        const url = 'app/rest/hardtoken/u2floginstart';
        return this.$http.post(url, {username}, {skipErrorAlert: true}).then(({data}) => data);
    }

    assingTokenAsSecondary(companyId,companyUserId,hardTokenId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/hardToken/${hardTokenId}?action=assign`;
        return this.$http.post(url).then(({data}) => data);
    }
    unAssingTokenAsSecondary(companyId,companyUserId,hardTokenId) {
        const url = `app/rest/v2/company/${companyId}/users/${companyUserId}/hardToken/${hardTokenId}?action=unassign`;
        return this.$http.post(url).then(({data}) => data);
    }
}

app.service('HardTokenResource', HardTokenResource);



// WEBPACK FOOTER //
// ./src/portal/rest/HardTokenResource.js